import { useSupabaseQuery } from './useSupabaseQuery';

/**
 * Dashboard agregado por colaborador. View v_gmail_sync_dashboard traz totais,
 * médias e contagens das últimas 24h/histórico.
 */
export function useSyncDashboard() {
  return useSupabaseQuery(
    (sb) => sb.from('v_gmail_sync_dashboard').select('*').order('colaborador_id'),
    []
  );
}

/**
 * Histórico cru de runs, para a tabela. Mantemos um limite generoso (50) mas
 * sem hardcode de 200 — paginação via `page` opcional para scroll futuro.
 */
export function useSyncRuns({ limit = 50, page = 0 } = {}) {
  return useSupabaseQuery(
    (sb) =>
      sb
        .from('gmail_sync_runs')
        .select('*', { count: 'exact' })
        .order('started_at', { ascending: false })
        .range(page * limit, (page + 1) * limit - 1),
    [limit, page]
  );
}
